import React, { useMemo } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { CkThemeProvider } from '@NP-Webber/crm-kit/dist/next/index.js';
import { StudyCalendarBoard } from '../../studyCalendar/StudyCalendar';
import { fetchStudyCalendar } from '../mishtameretPortalApi';
import { examsPath } from '../nav';

/**
 * לוח שנה בפורטל — the admin study calendar board, read-only, dressed in the portal theme:
 * the crm-kit tokens are re-pointed at the portal's gold accent, warm surfaces and Heebo (light + dark).
 * Exam rows link to the portal's exams of that frame. Station tablets do not keep view choices.
 */
const soft = (color, pct) => `color-mix(in srgb, ${color} ${pct}%, transparent)`;

function portalTokens(theme) {
  const dark = theme.mode === 'dark';
  return {
    '--ck-primary': theme.accent,
    '--ck-primary-hover': theme.accentSoft,
    '--ck-primary-soft': soft(theme.accent, dark ? 16 : 13),
    '--ck-primary-ring': soft(theme.accent, 38),
    '--ck-primary-line': theme.border,
    '--ck-on-primary': theme.accentContrast,
    '--ck-accent': theme.accent,
    '--ck-bg': 'transparent',
    '--ck-surface': theme.surface,
    '--ck-surface-2': dark ? 'rgba(26, 23, 20, 0.92)' : '#f6efe4',
    '--ck-surface-3': dark ? 'rgba(66, 57, 47, 0.85)' : '#ebe1d1',
    '--ck-hover': theme.surfaceHover,
    '--ck-border': theme.borderSoft,
    '--ck-border-strong': theme.border,
    '--ck-row-line': theme.borderSoft,
    '--ck-row-hover': theme.surfaceHover,
    '--ck-th-bg': dark ? 'rgba(18, 16, 14, 0.75)' : '#f3eadc',
    '--ck-th-text': theme.textMuted,
    '--ck-text': theme.text,
    '--ck-text-2': theme.textMuted,
    '--ck-text-3': soft(theme.text, 45),
    '--ck-danger': theme.danger,
    '--ck-danger-soft': soft(theme.danger, 14),
    '--ck-success': theme.success,
    '--ck-success-soft': soft(theme.success, 15),
    '--ck-neutral-soft': soft(theme.text, 8),
    '--ck-font': theme.fontBody,
    '--ck-font-display': theme.fontDisplay,
    '--ck-radius-lg': `${theme.radius}px`,
    '--ck-radius': '10px',
    '--ck-shadow-1': theme.shadow,
    fontFamily: theme.fontBody,
    color: theme.text,
  };
}

const CalendarScreen = () => {
  const { theme, mode, isStation = false } = useOutletContext();
  const navigate = useNavigate();
  const tokens = useMemo(() => portalTokens(theme), [theme]);

  return (
    <CkThemeProvider style="modern" mode={mode === 'light' ? 'light' : 'dark'} accent={theme.accent}>
      <div className="scal-portal" style={tokens}>
        <StudyCalendarBoard
          loadPlan={fetchStudyCalendar}
          prefsKey={isStation ? null : 'mishtameret-calendar'}
          onOpenExam={(frame) => navigate(examsPath(frame, isStation))}
        />
      </div>
    </CkThemeProvider>
  );
};

export default CalendarScreen;
